export default function(){

    return {
        mainNavigation: [
            {
                id:2, 
                title:'Logics', 
                link: '/logics',
                icon: '<path d="M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z"/><path fill="none" d="M0 0h24v24H0z"/>',



                showMegaMenu: true,
                showMainMenu: true,
            },
            // {
            //     id:2, 
            //     title:'Channels', 
            //     link: '/channels',
            //     icon: '<path fill="none" d="M0 0h24v24H0z"></path><path d="M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"></path>',
            //     showMegaMenu: true,
            //     showMainMenu: true,
            //     subMenuItems: [
            //         {
            //             id: 8,
            //             title:'Api',
            //             link: '/api',
            //             subMenuItems: [
            //                 {
            //                     id:9,
            //                     title: 'TouchPoints',
            //                     link: '/touchpoints'
            //                 },
            //                 {
            //                     id:10,
            //                     title: 'Logics',
            //                     link: '/logics'
            //                 }
            //             ]
            //         }
            //     ]
            // },
            {
                id:15, 
                title:'Analytics', 
                link: '/analytics',
                icon: '<path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/><path d="M0 0h24v24H0z" fill="none"/>',
                showMegaMenu: true,
                showMainMenu: true,
                // subMenuItems: [
                //     {
                //         id:16,
                //         title: 'Overview',
                //         link: ''
                //     },
                //     {
                //         id:17,
                //         title: 'Touchpoints',
                //         link: '/touchpoint'
                //     },
                //     {
                //         id:18,
                //         title: 'A/B Test',
                //         link: '/test'
                //     },
                //     {
                //         id:19,
                //         title: 'CustomAnalytics',
                //         link: '/customanalytics'
                //     }
                // ]
            },
            // {
            //     id:20, 
            //     title:'Database', 
            //     link: '/database',
            //     icon: '<g id="ICONS"><path d="M4,3.92v4H20v-4Zm13,3a1,1,0,1,1,1-1A1,1,0,0,1,17,6.92Z"></path><path d="M4,9.92v4H20v-4Zm13,3a1,1,0,1,1,1-1A1,1,0,0,1,17,12.92Z"></path><path d="M4,15.92v4H20v-4Zm13,3a1,1,0,1,1,1-1A1,1,0,0,1,17,18.92Z"></path></g>',
            //     showMegaMenu: true,
            //     showMainMenu: true,
            //     subMenuItems: [
            //         {
            //             id:21,
            //             title: 'Item',
            //             link: '/item'
            //         },
            //         {
            //             id:22,
            //             title: 'Event',
            //             link: '/event'
            //         },
            //         {
            //             id:23,
            //             title: 'User',
            //             link: '/user'
            //         }
            //     ]
            // },
            // {
            //     id:24,
            //     title:'Launchpad', 
            //     link: '/launchpad',
            //     icon: '<polygon points="17 4 16 5 13 8 12 9 10 9 8.5 9 7.75 9 7 9 9.49 11.51 9 12 8 13 10 15 11 16 12.5 14.5 15 17 15 12 19 8 20 7 21 3 17 4"></polygon><path d="M10,16,8,14,7,13a3.1,3.1,0,0,0-2,1c-1,1-2,4-2,4s1-.33,2-.79v.07A3.64,3.64,0,0,0,4,18c-1,1-2,4-2,4s3-1,4-2a3.64,3.64,0,0,0,.72-1h.07C6.33,20,6,21,6,21s3-1,4-2a3.1,3.1,0,0,0,1-2l-.5-.5Z"></path>',
            //     showMegaMenu: false,
            //     showMainMenu: true,
            // },
            // {
            //     id:25,
            //     title:'Settings', 
            //     link: '/settings',
            //     icon: '<g id="ICONS"><path d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"></path></g>',
            //     showMegaMenu: true,
            //     showMainMenu: false,
            //     subMenuItems: [
            //         {
            //             id:26,
            //             title: 'General',
            //             link: '/general'
            //         },
            //         {
            //             id:27,
            //             title: 'Profile',
            //             link: '/profile'
            //         },
            //         {
            //             id:28,
            //             title: 'Metric Settings',
            //             link: '/user'
            //         },
            //         {
            //             id:29,
            //             title: 'Algorithm Library',
            //             link: '/algorithmlibrary'
            //         },
            //         {
            //             id:30,
            //             title: 'Event Library',
            //             link: '/eventlibrary'
            //         },
            //         {
            //             id:31,
            //             title: 'User Management',
            //             link: '/settings/usermanagement'
            //         }
            //     ]
            // }
            {
                id:3,
                title:'Segmentations',
                link: '/segmentations',
                icon: '<svg fill="none" version="1.1" viewBox="144 144 512 512" xmlns="http://www.w3.org/2000/svg" stroke="#858080" stroke-width="16.896"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="m439.36 211.07c0 21.738-17.621 39.359-39.359 39.359s-39.363-17.621-39.363-39.359c0-21.738 17.625-39.359 39.363-39.359s39.359 17.621 39.359 39.359"></path> <path d="m374.81 502.34h50.383l12.594-125.95 25.191-12.594v-74c0-10.438-4.1484-20.449-11.531-27.832-7.3789-7.3789-17.391-11.527-27.832-11.527h-47.23c-10.438 0-20.449 4.1484-27.832 11.527-7.3828 7.3828-11.527 17.395-11.527 27.832v73.996l25.188 12.598z"></path> <path d="m580.5 494.46c-5.3516-46.445-58.016-84.938-128.95-97.77l-2.3633 23.617c54.316 10.941 94.465 39.359 99.738 73.84h-15.109v15.742h15.035c-6.6133 42.586-66.598 76.281-140.99 78.719v-15.426h-15.746v15.742c-74.391-2.2031-134.38-35.895-140.99-78.719h15.039v-15.746h-15.117c5.4336-34.32 45.422-62.977 99.738-73.84l-2.3633-23.617c-70.922 12.52-123.59 51.016-128.94 97.457h-16.293v15.742l16.215 0.003906c6.457 55.578 80.688 99.816 172.71 102.34v15.742h15.742l0.003906-15.742c92.023-2.3633 166.26-46.602 172.71-102.34h16.219v-15.746z"></path> <path d="m355.76 469.82-2.4414-24.48c-37.547 9.7578-63.527 31.801-63.527 56.992 0 34.793 49.359 62.977 110.21 62.977 60.852 0 110.21-28.184 110.21-62.977 0-25.191-25.977-47.23-63.527-56.992l-2.4414 24.48c20.785 7.082 34.484 18.973 34.484 32.512 0 21.727-35.266 39.359-78.719 39.359s-78.719-17.633-78.719-39.359c-0.003906-13.539 13.695-25.43 34.477-32.512z"></path> </g> </g></svg>',



                showMegaMenu: true,
                showMainMenu: true,
            },
            {
                id: 4,
                title: 'Data',
                link: '/data',
                icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px"><rect fill="none" height="24" width="24"/><path d="M3,14h4v-4H3V14z M3,19h4v-4H3V19z M3,9h4V5H3V9z M8,14h13v-4H8V14z M8,19h13v-4H8V19z M8,5v4h13V5H8z"/></svg>',
                showMegaMenu: true,
                showMainMenu: true,
            },
            {
                id:5,
                title:'Logics Detail',
            },
        ]
    }
}